export enum ContactType {
  Corporate = 1,
  Personal = 2,
}
